import { render, staticRenderFns } from "./data-box.vue?vue&type=template&id=acd2e054&scoped=true"
import script from "./data-box.vue?vue&type=script&lang=ts"
export * from "./data-box.vue?vue&type=script&lang=ts"
import style0 from "./data-box.vue?vue&type=style&index=0&id=acd2e054&prod&lang=less&scoped=true"
import style1 from "./data-box.vue?vue&type=style&index=1&id=acd2e054&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd2e054",
  null
  
)

export default component.exports